import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { getAreasByCountryId } from 'api/countryAreas';
import { accountIdSelector, isAgentSelector } from 'store/user/selectors';
import { IDataItem } from 'utils/fetchers';
import { isDefined } from 'utils/ramda';
import { getTagsString } from 'utils/tags';

export function useFetchCountyAreas(countryId?: string) {
  const accId = useSelector(accountIdSelector);
  const isAgent = useSelector(isAgentSelector);

  const countryAreasQueryRes = useQuery(['areas', accId, countryId], () => getAreasByCountryId(countryId), {
    enabled: isDefined(countryId),
  });

  const handledAreas =
    countryAreasQueryRes.data?.data?.map((item: IDataItem) => {
      return {
        name: item.name ?? item.handle,
        id: item.id.toString(),
        pageStatus: item.pageStatus,

        pageId: item?.pageId,
        optionActionAvailable: item.pageCurrentStep === 'page',
        showContentIndicator: isAgent && (item.systemWide || item?.shared),
        shared: item?.shared,
        tagsString: getTagsString(item.tags),
      };
    }) || [];

  return { handledAreas, countryAreasQueryRes };
}
